import React, {FunctionComponent, ReactNode} from 'react';
import "./content.scss";
import clsx from "clsx";

interface IProps {
    className?: string;
    children: ReactNode;
}

const Content:FunctionComponent<IProps> = (props) => {
    const {className = "", children} = props
    return (
        <div className={clsx(`content`, className)}>{children}</div>
    );
}

export default Content;